import { authHeader, BASE_URL, handleResponse } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnCreate } from '@helpers/product-events';

function get() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/pulse-ai/agents`, requestOptions).then(handleResponse);
}

function getLookup() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/pulse-ai/agents/lookup`, requestOptions).then(handleResponse);
}

function deleteAgent(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/pulse-ai/agents/${id}`, requestOptions).then(handleResponse);
}

function createOrUpdateAgent(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/pulse-ai/agents`, requestOptions)
        .then(handleResponse)
        .then(captureOnCreate(data, ProductEvent.AiAgentCreated, () => ({ channels: data.channels?.length })));
}

function updateStatusAgent(id, isActive) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/pulse-ai/agents/${id}:${isActive ? 'disable' : 'activate'}`, requestOptions).then(
        handleResponse,
    );
}

function sendPlaygroundMessage(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/pulse-ai/playground/messages`, requestOptions).then(handleResponse);
}

export const agentsService = {
    get,
    getLookup,
    deleteAgent,
    createOrUpdateAgent,
    updateStatusAgent,
    sendPlaygroundMessage,
};
